<template>
  <BaseDrawer :is-open="isOpen" @close="handleClose">
    <template #title> Change Supervisor Pin </template>
    <form
      class="flex h-full flex-col px-6 pb-6"
      @submit="onSubmit"
    >
      <div
        class="mb-2 flex flex-1 flex-col items-center justify-center"
      >
        <p class="mb-2 text-sm text-background-fg/70">
          Enter a new supervisor pin
        </p>
        <PinInput
          :model-value="formValues.pin"
          @update:model-value="setFieldValue('pin', $event)"
        />
      </div>

      <div>
        <ActionButtonPrimary
          class="w-full"
          type="submit"
          @click="handleSubmit"
        >
          Save Pin
        </ActionButtonPrimary>
      </div>
    </form>
  </BaseDrawer>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { useConfirmDialog } from "@vueuse/core"
import { changeSupervisorPin } from "@/services/changeSupervisorPin"

const { startLoading, stopLoading } =
  usePageBlockingLoading()
const {
  reveal,
  isRevealed: isOpen,
  confirm,
  cancel,
} = useConfirmDialog()

defineExpose({
  reveal,
})

const pinFormSchema = z.object({
  pin: z
    .string()
    .length(4, { message: "Pin must be 4 characters long" })
    .regex(/\d+/, {
      message: "Pin must only contain numeric characters",
    }),
})

const {
  handleSubmit,
  values: formValues,
  setFieldValue,
} = useForm({
  validationSchema: toTypedSchema(pinFormSchema),
  initialValues: {
    pin: "",
  },
})

const handleClose = () => cancel()

const onSubmit = handleSubmit(async (params) => {
  startLoading()
  try {
    await changeSupervisorPin(params)
    toast.success("Supervisor pin changed")
    confirm(params)
  } catch {
    toast.error("Failed to change supervisor pin")
  } finally {
    stopLoading()
  }
})
</script>
